module.exports = __webpack_public_path__ + "loader_small.c480137203770d1cdfb9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader_small.gif
// module id = 1508
// module chunks = 2